import { BACKEND_URL } from '../config'

export const getAppURL = appId => `${BACKEND_URL}/apps/${appId}/clients/runner`

export const getAppIconURL = (appId, size, radius) =>
  `${BACKEND_URL}/apps/${appId}/icon?size=${size}&radius=${radius}`

export const getAppIdURL = (host, path) => {
  host = encodeURIComponent(host)
  path = path || ''

  return `${BACKEND_URL}/app-search?host=${host}&path=${path}`
}
